import Text from 'components/commons/text';
import { styled } from 'styles';
import typography from 'styles/typography';

export const Container = styled('div', {
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
});

export const PanelSummaryContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  position: 'relative',
});

export const AbsolutePosition = styled('div', {
  position: 'absolute',
  inset: 0,
  overflowY: 'scroll',
  padding: 16,
  '@md': {
    padding: 20,
  },
});

export const PanelSummaryContent = styled('div', {
  borderRadius: 8,
  backgroundColor: '$secondary',
  display: 'flex',
  flexDirection: 'column',
  padding: 16,
  '@md': {
    padding: 20,
  },
});

export const PanelFooter = styled('div', {
  display: 'flex',
  width: '100%',
  padding: 16,
  justifyContent: 'space-between',
});

export const PanelFooterTotalText = styled(Text, {
  ...typography.body2,
  '@md': {
    ...typography.body1,
  },
  fontWeight: '600 !important',
});

export const PanelFooterPriceText = styled(Text, {
  ...typography.headline5,
  '@md': {
    ...typography.headline4,
  },
});

export const ItemTypeText = styled(Text, {
  ...typography.body5,
  fontWeight: '600 !important',
  '@md': typography.body3,
  variants: {
    isRed: {
      true: {
        color: '$error',
      },
    },
  },
});

export const ItemText = styled(Text, {
  ...typography.body5,
  '@xs': typography.body4,
  '@md': typography.body3,
});

export const ItemBasePriceText = styled(Text, {
  color: '$typeGray',
  ...typography.body6,
  '@xs': typography.body5,
  '@md': typography.body4,
});
